module.exports = __webpack_public_path__ + "img/select_button.e8ec5e62.svg";